module.exports = __webpack_public_path__ + "img/background.caf095e0.png";